
import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { addNewTenant, deleteTenantMember, getAvailableInternalPhone, getTenantMemberForUpdate, getTenantMemberSoftPhoneDetail, getTenantWebsiteDomainNameAndIdList, sendSoftPhoneDetailToTenantMemberEmail, toggleTenantMemberStatus, updateTenantMember } from "../apiRequests/tenantMember";
import { AddnewTenantErrorAction, AddnewTenantSuccessAction, deleteTenantMemberErrorAction, deleteTenantMemberSuccessAction, getAvailableInternalPhoneErrorAction, getAvailableInternalPhoneSuccessAction, getTenantMemberForUpdateErrorAction, getTenantMemberForUpdateSuccessAction, getTenantMemberSoftPhoneDetailErrorAction, getTenantMemberSoftPhoneDetailSuccessAction, getTenantWebsiteDomainErrorAction, getTenantWebsiteDomainSuccessAction, sendSoftPhoneDetailToTenantMemberErrorAction, sendSoftPhoneDetailToTenantMemberSuccessAction, toggleTenantMemberStatusErrorAction, toggleTenantMemberStatusSuccessAction, updateTenantMemberErrorAction, updateTenantMemberSuccessAction } from "../../actions/tenantmember";
import { GetTenantMemberForUpdateResponse, UpdateTenantMemberResponse } from "../../types/tenantMember/tenantMemberApiRequestType";

function* addNewTenantMemberHandler(action: any) {
    try {
        const response: { data: any } = yield call(addNewTenant, action.payload)
        yield put(
            AddnewTenantSuccessAction()
        )

    } catch (error: any) {
        yield put(
            AddnewTenantErrorAction({
                error: error?.message
            })
        )

    }
}

function* getAvailableInternalPhoneHandler(action: any) {
    try {
        const response: { data: any } = yield call(getAvailableInternalPhone)

        yield put(
            getAvailableInternalPhoneSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getAvailableInternalPhoneErrorAction({
                error: error?.message
            })
        )

    }
}


function* updateTenantMemberHandler(action: any) {
    try {
        const response: { data: UpdateTenantMemberResponse } = yield call(updateTenantMember, action.payload)

        yield put(
            updateTenantMemberSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            updateTenantMemberErrorAction({
                error: error?.message
            })
        )

    }
}

function* deleteTenantMemberHandler(action: any) {
    try {
        const response: { data: boolean } = yield call(deleteTenantMember, action.payload)

        yield put(
            deleteTenantMemberSuccessAction({
                params: response?.data
            })
        )

    } catch (error: any) {
        yield put(
            deleteTenantMemberErrorAction({
                error: error?.message
            })
        )

    }
}


function* getTenantMemberForUpdateHandler(action: any) {
    try {
        const response: { data: GetTenantMemberForUpdateResponse } = yield call(getTenantMemberForUpdate, action.payload)

        yield put(
            getTenantMemberForUpdateSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getTenantMemberForUpdateErrorAction({
                error: error?.message
            })
        )

    }
}

function* getTenantMemberSoftPhoneDetailHandler(action: any) {
    try {
        const response: { data: any } = yield call(getTenantMemberSoftPhoneDetail, action.payload)

        yield put(
            getTenantMemberSoftPhoneDetailSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getTenantMemberSoftPhoneDetailErrorAction({
                error: error?.message
            })
        )

    }
}

function* sendSoftPhoneDetailToTenantMemberEmailHandler(action: any) {
    try {
        const response: { data: any } = yield call(sendSoftPhoneDetailToTenantMemberEmail, action.payload)

        yield put(
            sendSoftPhoneDetailToTenantMemberSuccessAction()
        )

    } catch (error: any) {
        yield put(
            sendSoftPhoneDetailToTenantMemberErrorAction({
                error: error?.message
            })
        )

    }
}

function* toggleTenantMemberStatusHandler(action: any) {
    try {
        const response: { data: any } = yield call(toggleTenantMemberStatus, action.payload)

        yield put(
            toggleTenantMemberStatusSuccessAction()
        )

    } catch (error: any) {
        yield put(
            toggleTenantMemberStatusErrorAction({
                error: error?.message
            })
        )

    }
}

function* getTenantWebsiteDomainListHandler(action: any) {
    try {
        const response: { data: any } = yield call(getTenantWebsiteDomainNameAndIdList)

        yield put(
            getTenantWebsiteDomainSuccessAction({
                params:response?.data
            })
        )

    } catch (error: any) {
        yield put(
            getTenantWebsiteDomainErrorAction({
                error: error?.message
            })
        )

    }
}

function* watcherTenantMemberSaga() {
    yield all([takeLatest(Types.ADD_NEW_TENANT_MEMBER_REQUEST, addNewTenantMemberHandler)]);
    yield all([takeLatest(Types.GET_AVAILABLE_INTERNAL_PHONE_REQUEST, getAvailableInternalPhoneHandler)]);
    yield all([takeLatest(Types.UPDATE_TENANT_MEMBER_REQUEST, updateTenantMemberHandler)]);
    yield all([takeLatest(Types.DELETE_TENANT_MEMBER_REQUEST, deleteTenantMemberHandler)]);
    yield all([takeLatest(Types.GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_REQUEST, getTenantMemberForUpdateHandler)]);
    yield all([takeLatest(Types.GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_REQUEST, getTenantMemberSoftPhoneDetailHandler)]);
    yield all([takeLatest(Types.SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_REQUEST, sendSoftPhoneDetailToTenantMemberEmailHandler)]);
    yield all([takeLatest(Types.TOGGLE_TENANT_MEMBER_STATUS_REQUEST, toggleTenantMemberStatusHandler)]);
    yield all([takeLatest(Types.GET_TENANT_WEBSITE_DOMAIN_REQUEST, getTenantWebsiteDomainListHandler)]);







}

export default watcherTenantMemberSaga